import { AxiosRequestConfig } from 'axios';
import { ApiConfigs as ICSApiConfigs } from '@platform/ics-front-core';

class ApiConfigs extends ICSApiConfigs {
    getHeaderLinks: AxiosRequestConfig = {
        url: '/rkk/links',
        method: 'GET',
    };
}

export const apiConfigs = new ApiConfigs();
